import { Gamepad2, Globe, Settings, Users, Wallet } from 'lucide-react';
import type { ReactNode } from 'react';

import { AppLayout } from '../components/AppLayout';
import type { SidebarNavItem } from '../components/Sidebar';

const NAV_ITEMS: SidebarNavItem[] = [
  { path: '/user/lobby', label: 'Sảnh', icon: Gamepad2 },
  { path: '/user/accounts', label: 'Kho tài khoản', icon: Wallet },
  { path: '/user/proxy', label: 'Proxy', icon: Globe },
  { path: '/user/group', label: 'Nhóm', icon: Users },
  { path: '/user/settings', label: 'Cài đặt', icon: Settings },
];

export function UserLayout({ children }: { children?: ReactNode }) {
  return (
    <AppLayout navItems={NAV_ITEMS} logoAccent="Tool">
      {children}
    </AppLayout>
  );
}
